import axiosInstance from "./axiosConfig";

export const createCheckoutSession = async () => {
    const config = {
        method: "POST",
        url: '/payments/create-checkout-session/',
        headers: {
            "Content-Type": "application/json"
        }
    };

    const res = await axiosInstance(config);
    return res.data;
};

export const isSubscriptionRequiredError = (error) => {
    return error?.response?.status === 403 &&
           error?.response?.data?.code === "SUBSCRIPTION_REQUIRED";
};

export const verifyPaymentSession = async (sessionId) => {
    const config = {
        method: "GET",
        url: `/payments/verify-session/${sessionId}/`,
        headers: {
            "Content-Type": "application/json"
        }
    };

    const res = await axiosInstance(config);
    return res.data;
};
